
/* ============================================================
 * BLOOMI, moteur d'etoiles (canvas)
 * Usage : <div data-stars data-count="110" data-bright="10" data-area="93"></div>
 * De vraies etoiles : coeur lumineux + halo colore, aigrettes de
 * diffraction sur les brillantes, scintillement organique (double
 * sinus) et flares aleatoires, teintes variees (blanc, bleu lune,
 * or feerique, violet pale), derive tres lente. Rendu en additif,
 * ~30 fps, pause hors viewport et onglet cache, DPR et resize geres.
 * ============================================================ */
(function(){
  if(!window.requestAnimationFrame) return;
  var REDUCED=matchMedia('(prefers-reduced-motion:reduce)').matches;
  var TINTS=[[255,255,255],[207,224,255],[255,238,201],[228,217,255]];
  var TW=[.5,.3,.12,.08];
  function pickTint(){
    var r=Math.random(),acc=0;
    for(var i=0;i<TW.length;i++){acc+=TW[i];if(r<=acc)return TINTS[i];}
    return TINTS[0];
  }
  var CACHE={};
  function sprite(tint,bright){
    var key=tint.join(',')+(bright?'b':'s');
    if(CACHE[key])return CACHE[key];
    var S=bright?96:48,c=document.createElement('canvas');
    c.width=c.height=S;
    var x=c.getContext('2d'),h=S/2;
    var g=x.createRadialGradient(h,h,0,h,h,h);
    g.addColorStop(0,'rgba(255,255,255,1)');
    g.addColorStop(bright?.07:.18,'rgba('+tint[0]+','+tint[1]+','+tint[2]+',.9)');
    g.addColorStop(bright?.16:.4,'rgba('+tint[0]+','+tint[1]+','+tint[2]+',.25)');
    g.addColorStop(bright?.3:.7,'rgba('+tint[0]+','+tint[1]+','+tint[2]+',.05)');
    g.addColorStop(1,'rgba('+tint[0]+','+tint[1]+','+tint[2]+',0)');
    x.fillStyle=g;x.fillRect(0,0,S,S);
    if(bright){
      x.translate(h,h);
      for(var a=0;a<4;a++){
        var lg=x.createLinearGradient(0,0,h,0);
        lg.addColorStop(0,'rgba(255,255,255,.85)');
        lg.addColorStop(.25,'rgba('+tint[0]+','+tint[1]+','+tint[2]+',.3)');
        lg.addColorStop(.7,'rgba('+tint[0]+','+tint[1]+','+tint[2]+',.07)');
        lg.addColorStop(1,'rgba('+tint[0]+','+tint[1]+','+tint[2]+',0)');
        x.fillStyle=lg;
        x.beginPath();
        x.moveTo(1,0);x.quadraticCurveTo(h*.35,-.9,h,0);x.quadraticCurveTo(h*.35,.9,1,0);
        x.fill();
        x.rotate(Math.PI/2);
      }
    }
    CACHE[key]=c;return c;
  }
  function build(layer){
    var count=parseInt(layer.getAttribute('data-count')||'90',10);
    var brightN=parseInt(layer.getAttribute('data-bright')||'8',10);
    if(innerWidth<=760){count=Math.round(count*.6);brightN=Math.max(3,Math.round(brightN*.6));}
    var area=parseFloat(layer.getAttribute('data-area')||'94')/100;
    var cv=document.createElement('canvas');
    layer.appendChild(cv);
    var ctx=cv.getContext('2d');
    var W=0,H=0,stars=[],running=false,visible=false,raf=0,last=0;
    function gen(){
      stars=[];
      for(var i=0;i<count;i++){
        var bright=i<brightN,t=pickTint();
        /* loi de puissance : l immense majorite sont des tetes d epingle */
        var rr=bright?1.6+Math.random()*1.3:.35+Math.pow(Math.random(),2.4)*1.15;
        stars.push({
          x:Math.random(),y:Math.random()*area,
          r:rr,
          spr:sprite(t,bright),bright:bright,
          base:bright?.6+Math.random()*.3:.22+Math.pow(Math.random(),1.6)*.6,
          s1:.4+Math.random()*1.1,p1:Math.random()*6.283,
          s2:1.6+Math.random()*2.6,p2:Math.random()*6.283,
          rot:Math.random()*6.283,
          drift:(Math.random()*.0012+.0003)*(Math.random()<.5?-1:1),
          flareAt:4+Math.random()*14,flareDur:.9+Math.random()*.7
        });
      }
    }
    function resize(){
      var r=layer.getBoundingClientRect();
      if(r.width<2||r.height<2)return;
      var dpr=Math.min(devicePixelRatio||1,2);
      W=r.width;H=r.height;
      cv.width=Math.round(W*dpr);cv.height=Math.round(H*dpr);
      ctx.setTransform(dpr,0,0,dpr,0,0);
      if(!stars.length)gen();
      if(REDUCED)draw(8);
    }
    function draw(t){
      ctx.clearRect(0,0,W,H);
      ctx.globalCompositeOperation='lighter';
      for(var i=0;i<stars.length;i++){
        var s=stars[i];
        var tw=.78+.15*Math.sin(t*s.s1+s.p1)+.07*Math.sin(t*s.s2+s.p2);
        var a=s.base*tw,sc=1;
        if(s.bright){
          var ft=t-s.flareAt;
          if(ft>=0){
            if(ft<s.flareDur){
              var k=Math.sin(Math.PI*ft/s.flareDur);
              a=Math.min(1,a+.35*k);sc=1+.45*k;
            }else{s.flareAt=t+6+Math.random()*18;}
          }
        }
        var px=(((s.x+t*s.drift)%1)+1)%1*W,py=s.y*H;
        var d=s.r*(s.bright?12:4.5)*sc;
        ctx.globalAlpha=Math.max(0,Math.min(1,a));
        if(s.bright){
          ctx.save();ctx.translate(px,py);ctx.rotate(s.rot);
          ctx.drawImage(s.spr,-d/2,-d/2,d,d);
          ctx.restore();
        }else{
          ctx.drawImage(s.spr,px-d/2,py-d/2,d,d);
        }
      }
      ctx.globalAlpha=1;ctx.globalCompositeOperation='source-over';
    }
    function loop(ms){
      if(!running)return;
      raf=requestAnimationFrame(loop);
      if(ms-last<33)return;
      last=ms;
      draw(ms/1000);
    }
    function start(){if(running||REDUCED)return;running=true;raf=requestAnimationFrame(loop);}
    function stop(){running=false;cancelAnimationFrame(raf);}
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){
        visible=es[0].isIntersecting;
        if(visible)start();else stop();
      },{rootMargin:'140px'}).observe(layer);
    }else{visible=true;start();}
    document.addEventListener('visibilitychange',function(){if(document.hidden)stop();else if(visible)start();});
    addEventListener('resize',resize,{passive:true});
    resize();
  }
  function init(){
    var ls=document.querySelectorAll('[data-stars]');
    for(var i=0;i<ls.length;i++)build(ls[i]);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
